import * as React from "react";
import { useState } from "react";
import styled from "@mui/material/styles/styled";
import { ProfileSectionType } from "./profileContainer";
import { PatientColorMap } from "../layout/patientColorMap";
import {
  SearchComponent,
  UserEnterSymptomsMode,
} from "../components/search/searchComponent";
import { ProfileSectionItem } from "./profileSectionItem";

//region [[ Styles ]]

const ProfileSectionView = styled("div")(({ theme }) => ({
  boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.14)",
  borderRadius: "8px",
  marginBottom: "10px",
  padding: "20px",
}));

const SectionTitle = styled("div")(({ theme }) => ({
  fontSize: "15px",
  fontWeight: "bold",
  color: PatientColorMap.Primary,
  marginBottom: "10px",
}));

const SectionItems = styled("div")(({ theme }) => ({
  marginBottom: "10px",
}));

const SectionQuestion = styled("div")(({ theme }) => ({
  fontSize: "15px",
  fontWeight: 500,
  cursor: "pointer",

  color: PatientColorMap.Secondary,
  marginBottom: "10px",
}));

//endregion [[ Styles ]]

//region [[ Props ]]

export interface ProfileSectionProps {
  section: ProfileSectionType;
  question: string;
  addText: string;
  categories: any;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const ProfileSection = ({ ...props }: ProfileSectionProps) => {
  const [selected, setSelected] = useState("");

  const [showSearch, setShowSearch] = useState<boolean>(false);

  const [items, setItems] = useState<string[]>([]);

  const onChange = (e, cc) => {
    setItems([...items, cc.name]);
    setSelected("");
    setShowSearch(false);
  };

  const onClickQuestion = () => {
    setShowSearch(true);
  };

  const onRemove = (itemToRemove) => {
    setItems(items.filter((item) => item !== itemToRemove));
  };

  return (
    <ProfileSectionView>
      <SectionTitle>{props.section}</SectionTitle>

      <SectionItems>
        {items &&
          items.map((item) => (
            <ProfileSectionItem item={item} onRemove={onRemove} />
          ))}
      </SectionItems>

      {!showSearch && items.length === 0 && (
        <SectionQuestion onClick={onClickQuestion}>
          {props.question}
        </SectionQuestion>
      )}
      {!showSearch && items.length > 0 && (
        <SectionQuestion onClick={onClickQuestion}>
          {props.addText}
        </SectionQuestion>
      )}
      {showSearch && (
        <SearchComponent
          onChange={onChange}
          disabled={false}
          selected={selected}
          userEnterSymptom={UserEnterSymptomsMode.NONE}
          searchOptions={{ categories: props.categories }}
        />
      )}
    </ProfileSectionView>
  );
};
